'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _AnalyticsActions = require('../../actions/AnalyticsActions');

var _AuthenticationActions = require('../../actions/AuthenticationActions');

var _HubspotFormSubmissionActions = require('../../actions/HubspotFormSubmissionActions');

var _UserInfoActions = require('../../actions/UserInfoActions');

var _HublessAuth = require('../../auth/HublessAuth');

var _HublessAuth2 = _interopRequireDefault(_HublessAuth);

var _appStepRoutes = require('../../constants/appStepRoutes');

var _Auth = require('../../utils/Auth');

var _Auth2 = _interopRequireDefault(_Auth);

var _isFunnel = require('../../utils/isFunnel');

var _isFunnel2 = _interopRequireDefault(_isFunnel);

var _getRequestedStepFromPath = require('../../utils/getRequestedStepFromPath');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // TODO: import class
// TODO: import class


// We lock users into the flow because of programatic redirection. This is
// a super-cheap fix.
var _shouldAllowHistoryBack = false;

var DetectAuth = function (_React$Component) {
  _inherits(DetectAuth, _React$Component);

  function DetectAuth(props, context) {
    _classCallCheck(this, DetectAuth);

    var _this = _possibleConstructorReturn(this, (DetectAuth.__proto__ || Object.getPrototypeOf(DetectAuth)).call(this, props, context));

    _this.shouldHistoryBack();
    return _this;
  }

  _createClass(DetectAuth, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var ignoreHistoryBack = this.props.ignoreHistoryBack;

      var expectedKey = (0, _getRequestedStepFromPath.getRequestedStepFromPath)();

      if (!_shouldAllowHistoryBack || ignoreHistoryBack) {
        (0, _AnalyticsActions.trackEvent)('view', { screen: 'detect-auth' });
        if (!_isFunnel2.default.partnerClient()) {
          (0, _AnalyticsActions.trackEvent)('view', { screen: 'signup' }); // TODO ??
        }
        this.getAuthState();
      }

      _shouldAllowHistoryBack = expectedKey !== _appStepRoutes.GOOGLE_OAUTH;
    }
  }, {
    key: 'shouldHistoryBack',
    value: function shouldHistoryBack() {
      var _props = this.props,
          currentStepKey = _props.currentStepKey,
          ignoreHistoryBack = _props.ignoreHistoryBack;

      var expectedKey = (0, _getRequestedStepFromPath.getRequestedStepFromPath)();

      if (_shouldAllowHistoryBack && !ignoreHistoryBack) {
        if (currentStepKey !== expectedKey || expectedKey !== _appStepRoutes.GOOGLE_OAUTH) {
          window.history.back();
        }
      }
    }
  }, {
    key: 'getAuthState',
    value: function getAuthState() {
      var _this2 = this;

      var options = {};
      var portalId = this.props.getPortalId && this.props.getPortalId();
      if (portalId) {
        options.portalId = portalId;
      }

      this.props.AuthHandler.init(options).then(function (res) {
        return _this2.handleAuthed(!res.portalId);
      }).catch(function () {
        return _this2.handleNotAuthed();
      }).done();
    }
  }, {
    key: 'handleAuthed',
    value: function handleAuthed(isHubless) {
      this.logAuthState(true);

      // TODO: call action to store above data in auth store
      var userData = this.props.AuthHandler.get().user;
      this.props.updateUser({
        firstName: userData.get('first_name'),
        lastName: userData.get('last_name'),
        email: userData.get('email'),
        isHubless: isHubless
      });

      this.props.didDetectAuth();

      if (isHubless && this.props.handleAuthedNoPortal) {
        this.props.handleAuthedNoPortal();
      } else {
        this.props.handleAuthed();
      }
    }
  }, {
    key: 'handleNotAuthed',
    value: function handleNotAuthed() {
      this.logAuthState(false);
      (0, _AnalyticsActions.trackEvent)('redirect', {
        action: 'redirect unauthenticated',
        screen: 'detect-auth',
        userInitiated: false
      });

      this.props.didDetectUnauthed();
      this.props.handleNotAuthed();
    }
  }, {
    key: 'logAuthState',
    value: function logAuthState(isAuthed) {
      (0, _AnalyticsActions.trackEvent)('authState', {
        action: 'auth state',
        eventSubtype: isAuthed ? 'authed' : 'not-authed'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return DetectAuth;
}(_react2.default.Component);

DetectAuth.propTypes = {
  AuthHandler: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_Auth2.default.constructor), _propTypes2.default.instanceOf(_HublessAuth2.default.constructor)]).isRequired,
  getPortalId: _propTypes2.default.func,
  handleAuthed: _propTypes2.default.func.isRequired,
  handleAuthedNoPortal: _propTypes2.default.func,
  handleNotAuthed: _propTypes2.default.func.isRequired,
  ignoreHistoryBack: _propTypes2.default.bool,
  updateUser: _propTypes2.default.func.isRequired,
  submitSignupForm: _propTypes2.default.func.isRequired,
  user: _propTypes2.default.object,
  didDetectAuth: _propTypes2.default.func.isRequired,
  didDetectUnauthed: _propTypes2.default.func.isRequired,
  currentStepKey: _propTypes2.default.string
};


var mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.userInfo,
    currentStepKey: state.currentStep.get('key')
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return (0, _redux.bindActionCreators)({
    updateUser: _UserInfoActions.updateUser,
    submitSignupForm: _HubspotFormSubmissionActions.submitSignupForm,
    didDetectAuth: _AuthenticationActions._didDetectAuth,
    didDetectUnauthed: _AuthenticationActions._didDetectUnauthed,
    handleAuthed: ownProps.handleAuthed,
    handleAuthedNoPortal: ownProps.handleAuthedNoPortal,
    handleNotAuthed: ownProps.handleNotAuthed
  }, dispatch);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DetectAuth);
module.exports = exports['default'];